export default __webpack_public_path__ + "static/media/shipment.1e39ab47.png";